import { Card } from "antd";
import PropTypes from "prop-types";

import { Logo64 } from "../../../assets";
import "./ChatCard.css";

const ChatCard = ({ chatTitle, content }) => (
  <Card className="chat-card-main" bordered={false}>
    <Card.Meta
      className={chatTitle ? "" : "user-chat"}
      avatar={chatTitle && <Logo64 className="unstract-chat-logo" />}
      title={""}
      description={content}
    />
  </Card>
);

ChatCard.propTypes = {
  content: PropTypes.string.isRequired,
  chatTitle: PropTypes.string,
};

export { ChatCard };
